import React, { PropTypes } from 'react';

export default function RootAuth({ children }) {
  return (
    <div className="container">
      {children}
    </div>
  );
}

RootAuth.propTypes = {
  children: PropTypes.node.isRequired,
};



/** WEBPACK FOOTER **
 ** ./js/components/index/Root.auth.jsx
 **/